import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {
  CompetitorFilter,
  CompetitorResults,
  EventItem,
  Lookups,
  PagedFilter,
  Pages,
  Race,
  RaceSettings
} from "@model";
import {AuthenticationService, CompetitorResultsService} from "@services";
import {NgbDropdown} from "@ng-bootstrap/ng-bootstrap";
import {LIVE_RESULTS, PRIVATE_LIVE_RESULTS} from "../../../app-routing.module";
import {Router} from "@angular/router";

@Component({
  selector: 'app-live-results-photo-point',
  templateUrl: './live-results-photo-point.component.html',
  styleUrl: './live-results-photo-point.component.scss',
  standalone: false
})
export class LiveResultsPhotoPointComponent implements OnInit {
  @Input() event: EventItem | undefined = undefined;
  @Input() languages: Lookups[] = [];

  darkMode = true;

  competitorResult: CompetitorResults | undefined = undefined;
  race: Race | undefined = undefined;
  races: Race[] = [];
  isTeam = false;

  sameCountry: boolean | undefined;
  teamCountry: string | undefined;
  searchTerm = "";
  searchResults: CompetitorResults[] = [];

  @ViewChild('competitorDropdown') competitorDropdown?: NgbDropdown;

  constructor(
      private router: Router,
      public authenticationService: AuthenticationService,
      private competitorResultsService: CompetitorResultsService
  ) {
  }

  ngOnInit(): void {
    this.races = [...(this.event?.racesList ?? [])];
    this.selectRace(this.races.at(0));
  }

  selectRace(race: Race | undefined): void {
    if (!race) return;
    this.race = race;
    this.isTeam = RaceSettings.isTeamRace(race.raceSettings);
    this.competitorResult = undefined;
    this.resetSearch();
  }

  onInput(searchParam: string): void {
    this.searchTerm = searchParam;
    const trimmed = searchParam.trim();

    if (!trimmed || !this.race?.id) {
      this.searchResults = [];
      this.competitorDropdown?.close();
      return;
    }

    const competitorFilter = new CompetitorFilter();
    competitorFilter.name = trimmed;
    competitorFilter.raceId = this.race.id;
    const filter = new PagedFilter(new Pages(undefined, 1), competitorFilter);

    this.competitorResultsService.getCompetitorResults(filter, false).subscribe(result => {
      this.searchResults = result ?? [];
      this.searchResults.length
          ? this.competitorDropdown?.open()
          : this.competitorDropdown?.close();
    });
  }

  onFocus(): void {
    if (this.searchResults.length) {
      this.competitorDropdown?.open();
    }
  }

  selectCompetitor(result: CompetitorResults): void {
    this.competitorResult = result;

    const team = this.competitorResult.competitorResultsDetail?.team;
    if (this.isTeam && team) {
      const countries = team.map(tm => tm.cty);
      const uniqueCountries = new Set(countries);
      this.sameCountry = uniqueCountries.size <= 1;
      this.teamCountry = this.sameCountry ? countries[0] ?? undefined : undefined;
    }

    this.resetSearch();
  }

  goToLiveResults(): void {
    this.router.navigate([this.authenticationService.isAuthenticated() ? PRIVATE_LIVE_RESULTS : LIVE_RESULTS]);
  }

  back(): void {
    this.competitorResult = undefined;
    this.resetSearch();
  }

  private resetSearch(): void {
    this.searchTerm = "";
    this.searchResults = [];
    this.competitorDropdown?.close();
  }
}